import { Box } from '@mui/material';
import React from 'react';
import { type Accept, useDropzone } from 'react-dropzone';

const DropArea = ({
  renderChildren,
  accept,
  maxFiles = 1,
  onDrop,
  disabled,
}: {
  renderChildren: ({
    isDragging,
    acceptedFiles,
  }: {
    isDragging: boolean;
    acceptedFiles: File[];
  }) => React.ReactNode;
  accept: Accept;
  maxFiles?: number;
  onDrop: (acceptedFiles: File[]) => void;
  disabled?: boolean;
}) => {
  const { getRootProps, getInputProps, isDragActive, acceptedFiles } =
    useDropzone({
      accept,
      maxFiles,
      onDrop,
      disabled,
    });

  return (
    <Box {...getRootProps()}>
      {renderChildren({
        isDragging: isDragActive,
        acceptedFiles,
      })}
      <input
        {...getInputProps()}
        hidden
        type="file"
        id="input"
        data-testid={'drop-area'}
      />
    </Box>
  );
};

export default DropArea;
